/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface OrderControllerSearchMyOrders$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 주문 상태 필터
 */
  status?: 'PENDING_DEPOSIT' | 'DEPOSIT_COMPLETED' | 'CANCELED' | 'REFUND_REQUESTED' | 'REFUND_COMPLETED';

/**
 * 검색 시작일
 */
  startDate?: string;

/**
 * 검색 종료일
 */
  endDate?: string;

/**
 * 상품 ID 필터
 */
  productId?: string;

/**
 * 사용자 ID 필터 (내부용)
 */
  userId?: string;
}

export function orderControllerSearchMyOrders(http: HttpClient, rootUrl: string, params: OrderControllerSearchMyOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerSearchMyOrders.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('status', params.status, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('productId', params.productId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

orderControllerSearchMyOrders.PATH = '/api/orders/my';
